import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { Genre } from 'features/Genre/models/Genre';
import GenreFormDetail from 'features/Genre/pages/detail/components/GenreFormDetail';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';

interface EditModalInterface {
  genre: Genre;
  show: boolean;
  handleCloseModalEdit: (status: boolean, data?: Genre) => void;
}

function DetailModal({ genre, show, handleCloseModalEdit }: EditModalInterface) {
  const { t } = useTranslation();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  function onHide() {
    handleCloseModalEdit(false);
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('Genre.Headers.title')} />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        {genre && (
          <GenreFormDetail
            genre={genre}
            id={genre.id.toString()}
            handleCloseModalEdit={handleCloseModalEdit}
          ></GenreFormDetail>
        )}
      </Modal.Body>
    </Modal>
  );
}
export default DetailModal;
